import React  from'react';
import ScElements from './ScElementList.json';
import ScToolbarElement from './ScToolbarElement';

const ScToolbar = () => {
     /*  <div className="toolbar">
            {ScElements.map((element, index) => {
                return <ScToolbarElement key={index} element={element} />
            })}
            
        </div>*/
    return ( 
     
        <div className="list-group">
            {ScElements.map((element, index) => {
                return <ScToolbarElement key={index} element={element} />
            })}
        </div>
     );
}
 
export default ScToolbar;